import { useEffect, useContext } from 'react';
import { CONTEXTS } from 'figshelf-modules';

const DEFAULT_ICON = '/favicon.ico';

/**
 * When the logged-in user has selected a premium app icon asset, swap the
 * document <link rel="icon"> to that asset's assetUrl at runtime.
 * Restores the default favicon on unmount / when the asset is cleared.
 */
const usePremiumAppIcon = () => {
  const auth = useContext(CONTEXTS.AuthContext);

  useEffect(() => {
    const ps = auth?.userModel?.premiumSettings || auth?.user?.premiumSettings;
    const iconUrl = ps?.appIcon?.assetUrl;

    const links = Array.from(document.querySelectorAll("link[rel~='icon']"));

    if (iconUrl) {
      if (links.length > 0) {
        links.forEach((l) => { l.href = iconUrl; });
      } else {
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = iconUrl;
        document.head.appendChild(link);
      }
    }

    return () => {
      if (iconUrl) {
        Array.from(document.querySelectorAll("link[rel~='icon']")).forEach((l) => {
          l.href = DEFAULT_ICON;
        });
      }
    };
  }, [auth?.userModel?.premiumSettings, auth?.user?.premiumSettings]);
};

export default usePremiumAppIcon;
